// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GcpDiskType } from './GcpDiskType';
import {
  GcpDiskTypeFromJSON,
  GcpDiskTypeFromJSONTyped,
  GcpDiskTypeToJSON,
  GcpDiskTypeToJSONTyped,
} from './GcpDiskType';
import type { GcpGkeNodePoolTaint } from './GcpGkeNodePoolTaint';
import {
  GcpGkeNodePoolTaintFromJSON,
  GcpGkeNodePoolTaintFromJSONTyped,
  GcpGkeNodePoolTaintToJSON,
  GcpGkeNodePoolTaintToJSONTyped,
} from './GcpGkeNodePoolTaint';

/**
 *
 * @export
 * @interface GcpGkeNodePool
 */
export interface GcpGkeNodePool {
  /**
   *
   * @type {boolean}
   * @memberof GcpGkeNodePool
   */
  bestEffortProvision?: boolean;
  /**
   *
   * @type {number}
   * @memberof GcpGkeNodePool
   */
  diskSizeGb?: number;
  /**
   *
   * @type {GcpDiskType}
   * @memberof GcpGkeNodePool
   */
  diskType?: GcpDiskType;
  /**
   *
   * @type {number}
   * @memberof GcpGkeNodePool
   */
  initialNodeCount?: number;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof GcpGkeNodePool
   */
  labels?: { [key: string]: string };
  /**
   *
   * @type {number}
   * @memberof GcpGkeNodePool
   */
  localSsdCount?: number;
  /**
   *
   * @type {string}
   * @memberof GcpGkeNodePool
   */
  machineType?: string;
  /**
   *
   * @type {number}
   * @memberof GcpGkeNodePool
   */
  maxNodes?: number;
  /**
   *
   * @type {number}
   * @memberof GcpGkeNodePool
   */
  minNodes?: number;
  /**
   *
   * @type {boolean}
   * @memberof GcpGkeNodePool
   */
  multiZone?: boolean;
  /**
   *
   * @type {string}
   * @memberof GcpGkeNodePool
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof GcpGkeNodePool
   */
  nodeVersion?: string;
  /**
   *
   * @type {string}
   * @memberof GcpGkeNodePool
   */
  planeType?: string;
  /**
   *
   * @type {boolean}
   * @memberof GcpGkeNodePool
   */
  preemptible?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GcpGkeNodePool
   */
  _private?: boolean;
  /**
   *
   * @type {Array<GcpGkeNodePoolTaint>}
   * @memberof GcpGkeNodePool
   */
  taints?: Array<GcpGkeNodePoolTaint>;
  /**
   * deprecated
   * @type {Array<string>}
   * @memberof GcpGkeNodePool
   */
  zones?: Array<string>;
}

/**
 * Check if a given object implements the GcpGkeNodePool interface.
 */
export function instanceOfGcpGkeNodePool(
  value: object,
): value is GcpGkeNodePool {
  return true;
}

export function GcpGkeNodePoolFromJSON(json: any): GcpGkeNodePool {
  return GcpGkeNodePoolFromJSONTyped(json, false);
}

export function GcpGkeNodePoolFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GcpGkeNodePool {
  if (json == null) {
    return json;
  }
  return {
    bestEffortProvision:
      json['best_effort_provision'] == null
        ? undefined
        : json['best_effort_provision'],
    diskSizeGb: json['disk_size_gb'] == null ? undefined : json['disk_size_gb'],
    diskType:
      json['disk_type'] == null
        ? undefined
        : GcpDiskTypeFromJSON(json['disk_type']),
    initialNodeCount:
      json['initial_node_count'] == null
        ? undefined
        : json['initial_node_count'],
    labels: json['labels'] == null ? undefined : json['labels'],
    localSsdCount:
      json['local_ssd_count'] == null ? undefined : json['local_ssd_count'],
    machineType:
      json['machine_type'] == null ? undefined : json['machine_type'],
    maxNodes: json['max_nodes'] == null ? undefined : json['max_nodes'],
    minNodes: json['min_nodes'] == null ? undefined : json['min_nodes'],
    multiZone: json['multi_zone'] == null ? undefined : json['multi_zone'],
    name: json['name'] == null ? undefined : json['name'],
    nodeVersion:
      json['node_version'] == null ? undefined : json['node_version'],
    planeType: json['plane_type'] == null ? undefined : json['plane_type'],
    preemptible: json['preemptible'] == null ? undefined : json['preemptible'],
    _private: json['private'] == null ? undefined : json['private'],
    taints:
      json['taints'] == null
        ? undefined
        : (json['taints'] as Array<any>).map(GcpGkeNodePoolTaintFromJSON),
    zones: json['zones'] == null ? undefined : json['zones'],
  };
}

export function GcpGkeNodePoolToJSON(json: any): GcpGkeNodePool {
  return GcpGkeNodePoolToJSONTyped(json, false);
}

export function GcpGkeNodePoolToJSONTyped(
  value?: GcpGkeNodePool | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    best_effort_provision: value['bestEffortProvision'],
    disk_size_gb: value['diskSizeGb'],
    disk_type: GcpDiskTypeToJSON(value['diskType']),
    initial_node_count: value['initialNodeCount'],
    labels: value['labels'],
    local_ssd_count: value['localSsdCount'],
    machine_type: value['machineType'],
    max_nodes: value['maxNodes'],
    min_nodes: value['minNodes'],
    multi_zone: value['multiZone'],
    name: value['name'],
    node_version: value['nodeVersion'],
    plane_type: value['planeType'],
    preemptible: value['preemptible'],
    private: value['_private'],
    taints:
      value['taints'] == null
        ? undefined
        : (value['taints'] as Array<any>).map(GcpGkeNodePoolTaintToJSON),
    zones: value['zones'],
  };
}
